module.exports = __webpack_public_path__ + "static/media/zydus-logo.7e354939.jpg";